<template>

	<b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="4000"
      controls
      indicators
      background="#ababab"
      style="text-shadow: 1px 1px 2px #333;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
	
	<b-carousel-slide
	caption="Construction"
	text="We carry out all aspects of Groundworks & Civil Engineering"
	:img-src="images.slider1"
	></b-carousel-slide>
	
	<b-carousel-slide
	caption="Equipment"
	text=""
	:img-src="images.slider2"
	></b-carousel-slide>
	
	
	<!-- <b-carousel-slide
	caption="Safety"
	text="Safety of our clients and our staff is paramount."
	:img-src="images.slider3"
	></b-carousel-slide> -->
	  
    </b-carousel>
 
</template>

<script>
  export default {
    data() {
      return {
        slide: 0,
        sliding: null,
		images: {
                slider1: require('../../assets/Images/carousel/foxdown_slider_1.png'),
                slider2: require('../../assets/Images/carousel/foxdown_slider_2.png'),
                slider3: require('../../assets/Images/carousel/slider3.jpg'),
				
		}
		
      }
    },
    methods: {
      onSlideStart(slide) {
        this.sliding = true
      },
      onSlideEnd(slide) {
        this.sliding = false
      }
    }
  }
</script>

<style>

/* .carousel-inner > .item > img, .carousel-inner > .item > a > img {
    width: 100%;
} */
</style>